import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ListeningStatus from 'Components/Global/ListeningStatus';
import StudentVideo from 'Components/Student/StudentVideo';
import { listen } from 'Services/Listen';
import { COPY_STRINGS } from 'Constants/translatedCopy';
import { interventionType } from 'Constants/interventionSelectionConstants';

import cognateIcon from './cognate-icon.png';
import './Cognate.scss';

export default class Cognate extends React.Component {
  isMounted = true;

  constructor(props) {
    super(props);
    this.state = {showLipSyncVideo: false};
    this.speakCognate = this.speakCognate.bind(this);
    this.onIntroDone = this.onIntroDone.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    this.isMounted = true;
    this.speakCognate();
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  speakCognate(){
    const {wordMetadata} = this.props;    
    const {COGNATE} = wordMetadata;
    
    if(!(this.props.word && wordMetadata && COGNATE && COGNATE.spanish)) {
      this.close();
      return;
    }
    
    this.props.speech.speak({
      textToSpeak: COPY_STRINGS.intervention_strings.cognate_intro(this.props.word, COGNATE.spanish),
      onEnd: () => {
        if (!this.isMounted) return;
        if(wordMetadata && wordMetadata.VIDEO_URL) {
          this.setState({showLipSyncVideo: true});
        }
        else {
          this.onIntroDone();
        }        
      }     
    });
  }

  onIntroDone(){
    this.props.speech.speak({
      textToSpeak: "<break time=\"1s\"/>" + COPY_STRINGS.intervention_strings.cognate_now_you_say_it,
      onEnd: () => {
        if (!this.isMounted) return;
        listen({
          speech: this.props.speech,
          targetWord: this.props.word,
          callback: this.close,
          interventionType: interventionType.cognate
        });
      }
    });
  }

  close(){
    if (!this.isMounted) return;

    this.props.handleMessage({continueWithoutSpeaking: true, endOfPhrase: this.props.endOfPhrase})
  }

  render() {
    const { word, wordMetadata } = this.props;
    const wordClasses = cx({
      'word': true,
      'longWord': word ? (word.length > 8) : false,
    });

    return (
      <div className="wordInterventionModal">
        <div className="left">
          <div className="icon">
            <img className="interventionIcon" src={cognateIcon} alt="" />
          </div>
        </div>
        <div className="right">
          <div className="cognateContainer">
            {
              this.state.showLipSyncVideo && wordMetadata.VIDEO_URL 
              ? <StudentVideo videoURL={wordMetadata.VIDEO_URL} onDone={this.onIntroDone} speech={this.props.speech}/>
              : <div className={wordClasses}>{this.props.word}</div>          
            }
            <div className="listeningStatusWrapper"><ListeningStatus/></div>
          </div>
        </div>
      </div>
      
    );
  }
}

Cognate.propTypes = {
  word: PropTypes.string,
  wordMetadata: PropTypes.object,
  speech: PropTypes.object,
  handleMessage: PropTypes.func,
};